import React from 'react';
import I18n from 'i18n-js';

import { formatAmountCents, isEmptyMoneyResponse, IMoneyConfig } from '../money';
import { PriceDisplay } from './PriceDisplay';

interface IMoney {
  amountCents?: number;
  currency?: string;
}

interface IProps {
  moneyLow: IMoney;
  moneyHigh: IMoney;
  showFree?: boolean;
  auction?: boolean;
  displayConfig?: IMoneyConfig;
}

PriceDisplayRange.defaultProps = {
  showFree: false,
  auction: false,
  displayConfig: {},
};

export default function PriceDisplayRange(props: IProps) {
  const { moneyLow, moneyHigh, showFree, displayConfig } = props;
  if (isEmptyMoneyResponse(moneyLow) || isEmptyMoneyResponse(moneyHigh)) {
    return null;
  }

  const lowEqualsHigh =
    moneyLow.amountCents === moneyHigh.amountCents &&
    moneyLow.currency === moneyHigh.currency;

  if (lowEqualsHigh) {
    return (
      <PriceDisplay
        amountCents={moneyLow.amountCents}
        display={formatAmountCents(moneyLow, displayConfig)}
      />
    );
  }

  return (
    <div className="price-display-range">
      <PriceDisplay
        amountCents={moneyLow.amountCents}
        display={formatAmountCents(moneyLow, displayConfig)}
        showFree={showFree}
      />
      <span>{I18n.t('commons.priceDisplayRangeSeparator')}</span>
      <PriceDisplay
        amountCents={moneyHigh.amountCents}
        display={formatAmountCents(moneyHigh, displayConfig)}
        showFree={showFree}
      />
    </div>
  );
}
